export const quizCategories=[
  {value: 'all',label: 'All guideline topics'},
  {value: 'conventions',label: 'Conventions & Excludes'},
  {value: 'sequencing',label: 'Sequencing Rules'},
  {value: 'injury',label: 'Injury & 7th Characters'},
  {value: 'disease',label: 'Infectious & Chronic Diseases'},
];

export const icd10Questions=[
  {
    id: 'excludes-1',
    category: 'conventions',
    categoryLabel: 'Conventions & Excludes',
    question: 'An Excludes1 note appears beneath the code selected for a documented condition. What does the note mean?',
    options: [
      'Both conditions should always be reported together',
      'The excluded condition is not coded with the listed code',
      'The excluded condition is sequenced first',
      'The note applies only to inpatient claims',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines for Coding and Reporting: Excludes1 notes indicate that two conditions cannot be reported together under the stated coding instruction.',
    rationale: 'Excludes1 is a pure exclusion. The two conditions are considered mutually exclusive for that coding situation.',
  },
  {
    id: 'excludes-2',
    category: 'conventions',
    categoryLabel: 'Conventions & Excludes',
    question: 'What does an Excludes2 note indicate?',
    options: [
      'The two conditions cannot occur together',
      'The code is invalid for outpatient services',
      'The excluded condition is not part of the code, but both conditions may be reported',
      'The excluded condition must be coded first',
    ],
    answer: 2,
    reference: 'ICD-10-CM Official Guidelines: An Excludes2 note means the excluded condition is not included in the code, but the patient may have both conditions at the same time.',
    rationale: 'When both conditions are documented and reportable, an Excludes2 note allows both codes to be assigned.',
  },
  {
    id: 'code-first',
    category: 'conventions',
    categoryLabel: 'Conventions & Excludes',
    question: 'A tabular list instruction says “Code first” for an etiology. What should the coder do?',
    options: [
      'Report the manifestation before the etiology',
      'Report the underlying etiology before the manifestation',
      'Report only the manifestation',
      'Use an unspecified code instead',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: A “Code first” note identifies an underlying condition that should be sequenced before the current manifestation code.',
    rationale: 'The underlying disease is sequenced first, followed by the manifestation when an additional code is available and required.',
  },
  {
    id: 'use-additional',
    category: 'conventions',
    categoryLabel: 'Conventions & Excludes',
    question: 'What does a “Use additional code” note tell the coder?',
    options: [
      'The current code must be deleted',
      'An additional code may be needed to fully describe the condition',
      'The additional code replaces the first-listed code',
      'Only one code may be reported',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: “Use additional code” notes signal that another code should be assigned when needed to identify associated conditions or additional detail.',
    rationale: 'The note alerts the coder that the current code may not fully communicate the clinical picture by itself.',
  },
  {
    id: 'conventions-code-also',
    category: 'conventions',
    categoryLabel: 'Conventions & Excludes',
    question: 'What does a “Code Also” note generally indicate?',
    options: [
      'The current code must be removed',
      'Two codes may be needed to fully describe the condition',
      'The condition is never reportable',
      'The code applies only to inpatient claims',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: A “Code Also” note indicates that two codes may be required to fully describe a condition.',
    rationale: 'The note alerts the coder that another code may be needed, while sequencing depends on the reason for the encounter and the applicable instructions.',
  },
  {
    id: 'outpatient-diagnosis',
    category: 'sequencing',
    categoryLabel: 'Sequencing Rules',
    question: 'For an outpatient encounter, what is generally reported as the first-listed diagnosis?',
    options: [
      'The condition with the highest reimbursement',
      'The first condition alphabetically in the record',
      'The condition chiefly responsible for the services provided',
      'The patient’s oldest chronic condition',
    ],
    answer: 2,
    reference: 'ICD-10-CM Official Guidelines: The first-listed diagnosis is the condition, diagnosis, or other reason chiefly responsible for the services provided.',
    rationale: 'Outpatient sequencing is based on the reason for the encounter and the condition established after evaluation.',
  },
  {
    id: 'symptom-confirmed',
    category: 'sequencing',
    categoryLabel: 'Sequencing Rules',
    question: 'A patient is evaluated for chest pain, and the provider confirms acute pericarditis as the diagnosis. Which should generally be reported?',
    options: [
      'Chest pain only',
      'Acute pericarditis instead of the related symptom',
      'Chest pain as principal and pericarditis as secondary',
      'An unspecified cardiovascular code only',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: Signs and symptoms associated with a confirmed diagnosis are generally not coded separately unless otherwise instructed.',
    rationale: 'Once the definitive diagnosis is established, it generally replaces the related symptom code.',
  },
  {
    id: 'acute-chronic',
    category: 'sequencing',
    categoryLabel: 'Sequencing Rules',
    question: 'When both an acute and chronic form of the same condition are documented and separate subentries exist, how are they generally coded?',
    options: [
      'Code the chronic condition only',
      'Code the acute condition only',
      'Assign both, sequencing the acute condition first',
      'Assign an unspecified condition code',
    ],
    answer: 2,
    reference: 'ICD-10-CM Official Guidelines: When both acute and chronic forms are documented and separate index entries exist, code both, with the acute condition sequenced first.',
    rationale: 'The acute condition is sequenced before the chronic condition because it represents the immediate active problem.',
  },
  {
    id: 'principal-inpatient',
    category: 'sequencing',
    categoryLabel: 'Sequencing Rules',
    question: 'For an inpatient admission, the principal diagnosis is the condition established after study that is:',
    options: [
      'The first symptom documented',
      'Chiefly responsible for the admission',
      'The most expensive to treat',
      'Listed first by the physician',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: The principal diagnosis is the condition established after study to be chiefly responsible for occasioning the admission.',
    rationale: 'Inpatient principal diagnosis selection is based on the condition responsible for the admission after evaluation is complete.',
  },
  {
    id: 'sequencing-symptoms',
    category: 'sequencing',
    categoryLabel: 'Sequencing Rules',
    question: 'When no definitive diagnosis is established during an outpatient visit, what should generally be coded?',
    options: [
      'A suspected diagnosis as confirmed',
      'The documented signs and symptoms',
      'The most expensive possible condition',
      'No diagnosis code',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: In the outpatient setting, uncertain diagnoses such as probable, suspected, or rule-out conditions are not coded as established diagnoses.',
    rationale: 'When a definitive diagnosis is not established, report the signs and symptoms documented for the encounter.',
  },
  {
    id: 'injury-seventh',
    category: 'injury',
    categoryLabel: 'Injury & 7th Characters',
    question: 'What does the seventh character “A” generally indicate for an injury code?',
    options: [
      'A sequela encounter only',
      'A subsequent encounter during routine healing',
      'An initial encounter for active treatment',
      'A bilateral injury',
    ],
    answer: 2,
    reference: 'ICD-10-CM Official Guidelines: The seventh character A is used for the initial encounter while the patient is receiving active treatment.',
    rationale: 'Initial does not mean the first visit. It refers to active treatment such as surgical treatment, emergency care, or evaluation by a new physician.',
  },
  {
    id: 'injury-subsequent',
    category: 'injury',
    categoryLabel: 'Injury & 7th Characters',
    question: 'A patient returns for routine cast removal while an ankle fracture is healing normally. Which seventh character is generally appropriate?',
    options: [
      'A, initial encounter',
      'D, subsequent encounter',
      'S, sequela',
      'X, placeholder',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: The seventh character D identifies a subsequent encounter during the healing or recovery phase.',
    rationale: 'Routine care during healing is subsequent treatment, even when the patient is seeing a different provider.',
  },
  {
    id: 'injury-sequela',
    category: 'injury',
    categoryLabel: 'Injury & 7th Characters',
    question: 'A patient develops chronic nerve pain months after a healed injury. Which statement best describes sequela coding?',
    options: [
      'Code the original injury with A only',
      'Code only the original injury with D',
      'Code the residual condition first, followed by the injury code with S',
      'Use an unspecified injury code',
    ],
    answer: 2,
    reference: 'ICD-10-CM Official Guidelines: For sequelae, code the residual condition first, followed by the injury code with the seventh character S.',
    rationale: 'The current residual problem is the reason for treatment. The original injury identifies the cause of the late effect.',
  },
  {
    id: 'laterality',
    category: 'injury',
    categoryLabel: 'Injury & 7th Characters',
    question: 'A code family provides right, left, and unspecified options. The provider documents the right shoulder. Which code selection principle applies?',
    options: [
      'Use the unspecified option because laterality is optional',
      'Use the right-sided option',
      'Report both right and left',
      'Use a bilateral option',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: When laterality is available and documented, the code identifying the affected side should be assigned.',
    rationale: 'Specific documentation supports the right-sided code. Unspecified laterality should not be used when the record provides the detail.',
  },
  {
    id: 'injury-open-closed',
    category: 'injury',
    categoryLabel: 'Injury & 7th Characters',
    question: 'If the documentation does not state whether a fracture is open or closed, how is the fracture generally considered for coding purposes?',
    options: [
      'It is considered open',
      'It is considered closed',
      'It cannot be coded',
      'It must be coded as a sequela',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: When the documentation does not specify whether a fracture is open or closed, the fracture is coded as closed.',
    rationale: 'A fracture is presumed closed when the provider does not document an open fracture.',
  },
  {
    id: 'influenza-bronchitis',
    category: 'disease',
    categoryLabel: 'Infectious & Chronic Diseases',
    question: 'A patient has acute bronchitis due to influenza, and the tabular instructions identify influenza as the underlying cause. How should the conditions generally be sequenced?',
    options: [
      'Bronchitis first, then influenza',
      'Influenza first, then bronchitis when instructed',
      'Bronchitis only',
      'Influenza only in every case',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: When a combination of an etiology and manifestation is documented, follow the Tabular List sequencing instructions, including Code first and Use additional code notes.',
    rationale: 'When the guideline directs the underlying infectious disease to be sequenced first, influenza is reported before the bronchitis manifestation.',
  },
  {
    id: 'diabetes-manifestation',
    category: 'disease',
    categoryLabel: 'Infectious & Chronic Diseases',
    question: 'A patient with type 2 diabetes has documented diabetic chronic kidney disease. Which coding approach is generally required?',
    options: [
      'Report the kidney disease only',
      'Report diabetes only',
      'Assign the diabetes combination code and an additional CKD stage code when required',
      'Use an unspecified endocrine code',
    ],
    answer: 2,
    reference: 'ICD-10-CM Official Guidelines: Diabetes combination codes are used when the relationship between diabetes and a documented complication is established by the classification.',
    rationale: 'The diabetes combination code identifies the relationship, and an additional code may identify the CKD stage.',
  },
  {
    id: 'hypertension-ckd',
    category: 'disease',
    categoryLabel: 'Infectious & Chronic Diseases',
    question: 'When hypertension and chronic kidney disease are both documented, how does ICD-10-CM generally treat the relationship?',
    options: [
      'As unrelated unless the provider repeats the word “due to”',
      'As a presumed causal relationship under the classification',
      'By reporting hypertension only',
      'By reporting CKD only',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: A presumed causal relationship exists between hypertension and chronic kidney disease unless documentation clearly states they are unrelated.',
    rationale: 'The classification presumes a relationship between hypertension and CKD. Additional codes identify the stage and type of CKD as required.',
  },
  {
    id: 'disease-acute-chronic',
    category: 'disease',
    categoryLabel: 'Infectious & Chronic Diseases',
    question: 'When a patient has both an acute and chronic form of the same disease and separate codes exist, what is the general sequencing rule?',
    options: [
      'Report the chronic condition first',
      'Report the acute condition first and the chronic condition when supported',
      'Report only the unspecified condition',
      'Report only the chronic condition',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: When acute and chronic forms are both documented and separate codes exist, both may be assigned with the acute condition sequenced first.',
    rationale: 'The acute condition represents the active episode and is generally sequenced before the chronic condition.',
  },
  {
    id: 'disease-manifestation',
    category: 'disease',
    categoryLabel: 'Infectious & Chronic Diseases',
    question: 'What is the purpose of an etiology and manifestation coding relationship?',
    options: [
      'To report only the symptom',
      'To identify both the underlying cause and the resulting condition when instructed',
      'To replace all secondary diagnoses',
      'To avoid using combination codes',
    ],
    answer: 1,
    reference: 'ICD-10-CM Official Guidelines: Etiology and manifestation instructions identify the underlying disease and the condition resulting from it.',
    rationale: 'Following the Tabular List instructions ensures that both the cause and manifestation are reported in the required order.',
  },
];

function shuffleQuestions(questions) {
  return [...questions].sort(() => Math.random() - 0.5);
}

function getQuestionsForQuiz(mode,category) {
  const pool=category==='all'
    ? icd10Questions
    : icd10Questions.filter((question)=> question.category===category);
  const count=mode==='quick' ? 5 : 15;
  const shuffledPool=shuffleQuestions(pool);
  const selectedQuestions=[];

  for (let index=0;index<count;index += 1) {
    const sourceQuestion=shuffledPool[index % shuffledPool.length];
    const cycle=Math.floor(index / shuffledPool.length);

    selectedQuestions.push({
      ...sourceQuestion,
      id: `${sourceQuestion.id}-${cycle}-${index}`,
    });
  }

  return selectedQuestions;
}

export {getQuestionsForQuiz};